import type { BreakpointsOptions, PaletteColorOptions } from '@mui/material';

export const BREAKPOINTS_OPTIONS: BreakpointsOptions = {
	values: {
		xs: 0, // Valor por defecto de Material UI.
		sm: 600, // Valor por defecto de Material UI.
		md: 900, // 769px — 1024px (Small screens, laptops)
		lg: 1200, // 1025px — 1200px (Desktops, large screens)
		xl: 1536, // 1201px and more — (Extra large screens, TV)
	},
};

export const ERROR_COLOR: PaletteColorOptions = {
	main: '#FD5A6F',
};

export const PRIMARY_COLOR: PaletteColorOptions = {
	main: '#1063AC',
};

export const SUCCESS_COLOR: PaletteColorOptions = {
	main: '#1ECB85',
};

export const SPACING = 12;
